<template>
  <el-dialog
    :title="title"
    :visible.sync="visible"
    append-to-body
    width="50%">
    <el-form
      :model="ruleForm"
      :rules="rules"
      ref="ruleForm"
      label-width="110px"
      class="orgForm"
      :disabled="disabled"
    >
      <el-form-item label="公证费用" prop="charge">
        <el-input size="small" v-model="ruleForm.charge">
          <template slot="append">￥</template>
        </el-input>
      </el-form-item>



      <el-form-item label="公证类别" prop="lb">
        <el-select size="small" v-model="ruleForm.lb" clearable placeholder="请选择">
          <el-option
            v-for="item in lbOptions"
            :key="item.label"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="公证类型" prop="lx">
        <el-select size="small" v-model="ruleForm.lx" clearable placeholder="请选择">
          <el-option
            v-for="item in lxOptions"
            :key="item.label"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="公证事项" prop="notaryItem">
        <el-select size="small" v-model="ruleForm.notaryItem" clearable placeholder="请选择">
          <el-option
            v-for="item in gzItems"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="公证员" prop="notaryId">
        <el-select size="small" v-model="ruleForm.notaryId" clearable placeholder="请选择">
          <el-option
            v-for="item in notarys"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="助理" prop="assistantId">
        <el-select size="small" v-model="ruleForm.assistantId" clearable placeholder="请选择">
          <el-option
            v-for="item in assistantOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="紧急程度" prop="priority">
        <el-select size="small" v-model="ruleForm.priority" clearable placeholder="请选择">
          <el-option
            v-for="item in priorityOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </el-form-item>

      <el-form-item>
        <el-button size="small" type="primary" @click="submitForm('ruleForm')">保存</el-button>
        <el-button size="small" @click="resetForm('ruleForm')">重置</el-button>
      </el-form-item>
    </el-form>
  </el-dialog>
</template>

<script>
import {conVertDate} from '@/utils/tools.js';
import { mapGetters } from "vuex";
export default {
  props: {
    openType: {
      type: String,
      required: true
    },
  },
  data() {
    var checkNum = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('请填写价格'));
      } else if (!/^\d+$/.test(value)) {
        return callback(new Error('价格只能为数字'));
      } else {
        return callback()
      }
    };
    var checkNo = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('请填写编码'));
      } else if (!/^[a-zA-Z0-9]+$/.test(value)) {
        return callback(new Error('编码只能包含数字或字母'));
      } else {
        return callback()
      }
    };
    return {
      visible: false,
      title: '',
      ruleForm: {
        charge: "100", // 公证费用
        // deptId: "", // 机构编码
        lb: 0, // 类别
        lx: 0, // 类型
        notaryItem: 0, // 公证事项，传公证事项下来的id
        notaryId: 0, // 公证员编码
        notaryName: "", // 公证员姓名
        assistantId: 0, // 助理编码
        assistantName: "", // 助理姓名
        priority: 0, // 紧急度
        acceptDate: "2020-08-03", // 日期
      },
      disabled: false,
      rules: {
        charge: [
          { required: true, message: '请输入费用', trigger: 'blur' },
          {validator: checkNum, trigger: 'blur'}
        ],
        deptId: [
          { required: true, message: '请输入编码', trigger: 'blur' },
          {validator: checkNo, trigger: 'blur'}
        ],
        lb: [
          { required: true, message: '请选择类别', trigger: 'change' }
        ],
        lx: [
          { required: true, message: '请选择类型', trigger: 'change' }
        ],
        notaryItem: [
          { required: true, message: '请选择公证事项', trigger: 'change' }
        ],
        notaryId: [
          { required: true, message: '请选择公证员', trigger: 'change' }
        ],
        assistantId: [
          { required: true, message: '请选择助理', trigger: 'change' }
        ], 
        priority: [
          { required: true, message: '请选择紧急程度', trigger: 'change' }
        ],
      },
      lbOptions: [
        {label: '合同公证',value: 0},
        {label: '电子存证',value: 1},
        {label: '赋强公证',value: 2}
      ],
      lxOptions: [
        {label: '借款合同',value: 0}
      ],
      notaryItemOptions: [
        // {label: '财产',value: 0},
        // {label: '学历',value: 1},
        // {label: '遗嘱',value: 2}
      ],
      notaryOptions: [
        // {label: '蔡徐坤',value: 0},
        // {label: '罗志祥',value: 1},
      ],
      assistantOptions: [
        {label: '助理A',value: 0},
        {label: '助理B',value: 1},
      ],
      priorityOptions: [
        {label: '普通',value: 0},
        {label: '加急',value: 1},
      ]
    };
  },
  computed: {
    ...mapGetters({
      storeCaseInfo: "case/caseInfo",
      gzItems: "enum/gzItems", // 公证事项
      notarys: "enum/notarys", // 公证员
    }),
  },
  created() {
    
  },
  watch: {
    openType: {
      immediate: true,
      handler(newValue) {
        switch (newValue) {
          case "see":
            this.title = "查看公证信息";
            break;
          case "add":
            this.title = "新增公证信息";
            break;
          case "edit":
            this.title = "编辑公证信息";
            break;
          default:
            break;
        }
      }
    },
    storeCaseInfo: {
      immediate: true,
      handler(newValue) {
        if (JSON.stringify(newValue) != '{}') {
          this.ruleForm = JSON.parse(JSON.stringify(newValue));
        }
      }
    },
    // 公证事项
    gzItems: {
      immediate: true,
      handler(newArr) {
        if (newArr.length !== 0) {
          this.ruleForm.notaryItem = newArr[0].value;
        }
      }
    },
    // 公证员
    notarys: {
      immediate: true,
      handler(newArr) {
        if (newArr.length !== 0) {
          this.ruleForm.notaryId = newArr[0].value;
        }
      }
    },
  },
  mounted() {
    
  },
  methods: {
    // 提交
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.ruleForm.notaryName = this.reverseSearch(this.ruleForm.notaryId, this.notarys);
          this.ruleForm.assistantName = this.reverseSearch(this.ruleForm.assistantId, this.assistantOptions);
          this.ruleForm.acceptDate = conVertDate(new Date(), false);
          console.log(this.ruleForm);
          // console.log(JSON.parse(JSON.stringify(this.ruleForm)));
          this.$store.commit('case/updateCaseInfo', {...this.ruleForm});
          console.log(this.$store.state.case.caseInfo);
          this.close();
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    // 通过value去查询options的label
    reverseSearch(value, options) {
      let label = null;
      options.forEach(item => {
        if (item.value == value) {
          label = item.label;
          return;
        }
      })
      return label;
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    open() {
      this.visible = true;
    },
    close() {
      this.visible = false;
    },
  }
};
</script>
<style lang="less" scoped>
.orgForm {
  width: 80%;
  margin: 0 auto;
}
.el-form-item {
  margin-bottom: 12px;
}
.el-select {
  display: inline-block;
  position: relative;
  width: 100%;
}
/deep/ .el-input-group__append{
  padding: 0 10px;
}
</style>